import React, { Component } from 'react';

class FooterLinks extends Component {
  constructor(props) {
    super(props);
  }

  getFooterLinksHTML() {
    const items = this.props.data.items;
    let html = items.map((item, index) =>
      <li key={index}><a href={item.href}>{item.label}</a></li>
    );

    return (
      <ul>
        {html}
      </ul>
    );
  }

  render() {
    return (
      <nav className="row footer-legal-list">
        <div className="col-xs-12 hidden-xs">
          {this.getFooterLinksHTML()}
        </div>
        <div className="col-xs-12">
          <div className="row">
            <div className="col-xs-12 col-sm-6 copyright">{this.props.data.copyrightText}</div>
            <div className="col-xs-12 col-sm-6 holdings">
              <a href={this.props.data.telecomHoldings.link} target="_blank"><img loading='lazy' className="img-responsive" src={this.props.data.telecomHoldings.src} alt={this.props.data.telecomHoldings.alt} /></a>
              <a href={this.props.data.holdings.link} target="_blank"><img loading='lazy' className="img-responsive" src={this.props.data.holdings.src} alt={this.props.data.holdings.alt} /></a>
            </div>
          </div>
        </div>

      </nav>
    )
  }
}

export default FooterLinks;